import React, { FunctionComponent } from 'react';

import callOutGifSrc from './assets/JustGiving_Awards_2023.gif';
import callOutImgSrc from './assets/JustGiving_Awards_2023.png';
import config from '../../config';
import styles from './CallOut.module.scss';

export const CallOut: FunctionComponent = () => {

  const prefersReducedMotion = !window.matchMedia(
    '(prefers-reduced-motion: no-preference)'
  ).matches;

  const callOutImg = prefersReducedMotion ? callOutImgSrc : callOutGifSrc;
  return (
    <section className={styles.callOut}>
      <div className={`container ${styles.container}`}>
        <div className={`jg-space-mtsm ${styles.callOutWrapper}`}>
          <div className={`jg-display-ib ${styles.content}`}>
            <h2 className={`jg-display-ib jg-space-ptmd ${styles.header}`}>
              Do you know a fundraising hero?
            </h2>

            <p className={`jg-display-ib ${styles.description} jg-space-mtsm`}>
              The JustGiving Awards celebrate the people who fill us with inspiration, pride and hope.
            </p>

            <p className={`jg-display-ib ${styles.description} jg-space-mtsm`}>
              They don't ask for thanks, but they couldn't be more deserving.
              So, whether it's just to say, "well done", "we're proud of you!" or "the world's a better place with you in it,"
              say it by nominating them before <b>Monday 29th May 2023.</b>
            </p>

            <div
              className={`jg-space-mtsm ${styles.buttonWrapper}`}
            >
              <a
                className={`jg-btn--ghost jg-space-mbm ${styles.button}`}
                href={config.lmUrl}
              >
                Nominate a JustGiver
              </a>
            </div>
          </div>

          <div className={`jg-display-ib ${styles.content} jg-flex-asc`}>
            <a href={config.lmUrl} tabIndex={-1} aria-hidden>
              <img
                src={callOutImg}
                alt=""
                className="jg-space-psm callOut-img"
              />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
